import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import md5 from 'js-md5';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueI18n from 'vue-i18n'
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.css';
import 'animate.css';
import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/node_modules/video.js/dist/video-js.css'

import "@/assets/styles/font.css"; // 字体
import 'vue-video-player/src/custom-theme.css'
 import '@/utils/rem'//缩放
 import '@/utils/resize'//监听页面大小刷新
Vue.use(VideoPlayer)

import mixin from '@/components/mixin.js'
Vue.mixin(mixin);

Vue.prototype.$bus = new Vue();

Vue.prototype.$swiper = Swiper;

Vue.prototype.$md5 = md5;

Vue.config.productionTip = false
Vue.use(ElementUI);

import loadingPlugin from '@/components/loadingPlugin';// 假设把loadingPlugin.js放在了plugins文件夹下
Vue.use(loadingPlugin);

router.beforeEach((to, from, next) => {
     // 让页面回到顶部
     // document.documentElement.scrollTop = 0
	 var element = document.documentElement.scrollTop ? document.documentElement : document.documentElement.scrollTop==0?document.documentElement:document.body;
	 	element.scrollTop =0;
     // 调用 next()，一定要调用 next 方法，否则钩子就不会被销毁
    next()
 })
 Vue.use(VueI18n)
 const i18n = new VueI18n({
   locale: localStorage.getItem('i18n-lang') || 'eu', // 语言标识 //this.$i18n.locale // 通过切换locale的值来实现语言切换
   messages: {
     'zh': require('./VueI18n/zh.json'),  //
     'en': require('./VueI18n/en.json'),
     'eu': require('./VueI18n/en.json')
   }
 })
 // 用于替换i18的错误
 // Vue.prototype.$t = (e) => {return e };
 console.log=()=>{};
 
new Vue({
	router,
	store,
	i18n,
  render: h => h(App),
}).$mount('#app')
